import * as React from "react";
import { ReactSVG } from 'react-svg';
import * as theme from '../../theme.js';

interface Props {
  src:string;
  className?:string;
  classNameSVG?:string;
  gradient?:boolean;
  fill?:string;
  title:string;
}

export const SVG = (props:Props) =>
 <ReactSVG
   className={props.className}
   beforeInjection={(svg) => {

     // class
      if(props.classNameSVG) {
        svg.classList.add(props.classNameSVG);
      }

      // title
      const title = document.createElementNS('http://www.w3.org/2000/svg', "title");
      title.appendChild(document.createTextNode(props.title));
      svg.insertBefore(title, svg.firstChild);

      // gradient
      if(props.gradient) {
        addGradient(svg);
      }
      // fill
      else if(props.fill) {
        updateFill(svg, props.fill);
      }

   }}
   src={props.src}
 />
;

/**
 *
 * @param color
 * @param svg
 */
function updateFill(svg, color) {
  const elementNames = ["g","path"];
  for(let j=0;j<elementNames.length;j++) {
    const children = svg.getElementsByTagName(elementNames[j]);
    for (let i = 0; i < children.length; i++) {
      if (children[i].hasAttribute("fill")) {
        children[i].setAttribute("fill", color);
      }
    }
  }
}

/**
 *
 * imitates: "background: linear-gradient(110.06deg, #7D2E68 1.75%, #003595 100%);"
 *
 * @param svg
 */
function addGradient(svg) {
  const LG = document.createElementNS('http://www.w3.org/2000/svg', "linearGradient");
  LG.setAttribute("id", "gradient");
  LG.setAttributeNS('http://www.w3.org/2000/svg', "gradientUnits", 'userSpaceOnUse');

  LG.setAttribute("x1", "-10.23%");
  LG.setAttribute("x2", "110.23%");
  LG.setAttribute("y1", "28.01%");
  LG.setAttribute("y2", "71.99%");
  const stop1 = document.createElementNS('http://www.w3.org/2000/svg', "stop");
  stop1.setAttribute("offset", ".018");
  stop1.setAttribute("stop-color", theme.Byzantium);
  LG.appendChild(stop1);
  const stop3 = document.createElementNS('http://www.w3.org/2000/svg', "stop");
  stop3.setAttribute("offset", "1");
  stop3.setAttribute("stop-color", theme.EgyptianBlue);
  LG.appendChild(stop3);
  svg.insertBefore(LG, svg.firstChild);
  const children = svg.getElementsByTagName("path");
  for (let i = 0; i < children.length; i++) {
    children[i].setAttribute("fill", "url(#gradient)");
  }
}
